 
export default async (session, {menu}) => {
  if(menu === 'record') {
          

    window.location.href =  `https://smarthealth-line.dietz.asia/data?route=${encodeURIComponent(`/data?redirect=${encodeURIComponent('https://smarthealth.dietz.asia/user-smart-health')}`)}&token_member=${encodeURIComponent(session)}`
  }
  else if(menu === 'risk') {
    window.location.href = "/user-smart-health#d-smarth-health-trending-graph";
  }

  else if(menu === 'display') {
    window.location.href =  `https://liff.line.me/2006538121-y9BkoYb3?token_member=${encodeURIComponent(session)}`;
  }

}